import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const initStateSubscriptionList = {
  subscriptionList: { data: null, loading: false, error: null },
};

export const subscriptionList = createAsyncThunk(
  "payment/subscriptionList",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    const token = localStorage.getItem("token");
    if (!token) return rejectWithValue({ error: "Необходима авторизация" });

    return await axios
      .get(`${process.env.REACT_APP_SERVER_API}/payments/apipay/subscriptions/`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => fulfillWithValue(res.data))
      .catch((res) =>
        rejectWithValue(
          res.response?.data || { error: "Ошибка при загрузке подписок" }
        )
      );
  }
);

export const reducerSubscriptionList = {
  [subscriptionList.pending]: (state) => {
    state.subscriptionList.loading = true;
    state.subscriptionList.error = null;
  },
  [subscriptionList.fulfilled]: (state, action) => {
    state.subscriptionList.loading = false;
    state.subscriptionList.data = action.payload;
    state.subscriptionList.error = null;
  },
  [subscriptionList.rejected]: (state, action) => {
    state.subscriptionList.loading = false;
    state.subscriptionList.error = action.payload;
  },
};
